import * as React from 'react';
import { memo } from 'react';
import styled from 'styled-components';

import { IPaletteSection } from './paletteTypes';
import { PaletteRow } from './PaletteRow';

interface IPaletteResultsListProps {
  sections: IPaletteSection[];
  /** Flat cursor across all rows (group headers are skipped). */
  selectedIndex: number;
  onHover: (flatIndex: number) => void;
}

/**
 * Grouped search results (Commands → Students → Groups → Courses → Teachers →
 * Users). Rows share ONE flat cursor: the running `flatIndex` advances only over
 * selectable rows, so `↑/↓` never lands on a section header.
 */
export const PaletteResultsList = memo<IPaletteResultsListProps>(
  ({ sections, selectedIndex, onHover }) => {
    let flatIndex = -1;
    return (
      <>
        {sections.map((section) => (
          <Section key={section.key}>
            <SectionTitle>{section.title}</SectionTitle>
            {section.items.map((item) => {
              flatIndex += 1;
              const index = flatIndex;
              return (
                <PaletteRow
                  key={item.key}
                  item={item}
                  selected={index === selectedIndex}
                  onHover={() => onHover(index)}
                  onActivate={item.activate}
                />
              );
            })}
          </Section>
        ))}
      </>
    );
  },
);

const Section = styled.div`
  margin-bottom: 6px;
`;

const SectionTitle = styled.div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--k-fg-616e78);
  padding: 8px 12px 4px;
`;
